// Export legacy compatibility functions
export { decodeFermentationDataFile, getFermentationsFromDataFile, } from "./fermentation-data-file";
// Export new parser interfaces and classes
export { BaseFermentationParser, } from "./parser-interface";
export { FermentationParserRegistry, parserRegistry, } from "./parser-registry";
// Export new parser implementations
export { DasGipParser } from "./dasgip";
export { BiostreamParser } from "./biostream";
export { ApplikonParser } from "./applikon";
export { OGAParser } from "./oga";
// Auto-register all parsers when this module is imported
import { DasGipParser } from "./dasgip";
import { BiostreamParser } from "./biostream";
import { ApplikonParser } from "./applikon";
import { OGAParser } from "./oga";
import { parserRegistry } from "./parser-registry";
// Register all available parsers
parserRegistry.registerParser(new DasGipParser());
parserRegistry.registerParser(new BiostreamParser());
parserRegistry.registerParser(new ApplikonParser());
parserRegistry.registerParser(new OGAParser());
//# sourceMappingURL=index.js.map